import React, { useState, useEffect } from "react";
import useAxios from "../../utils/useAxios";

const UserHealthProfiles = () => {
  const [healthProfiles, setHealthProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const axiosAPI = useAxios();

  const fetchHealthProfiles = async () => {
    try {
      const response = await axiosAPI.get(`/api/recipe-management/health-profiles`);
      if (response.data.success) {
        setHealthProfiles(response.data.healthProfiles);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching health profiles:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHealthProfiles();
  }, []);

  return (
    <div className="container">
      <div className="page-inner">
        <div className="page-header">
          <h3 className="fw-bold mb-3">Health Profiles</h3>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">User Health Profiles</h4>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="display table table-striped table-hover">
                    <thead>
                      <tr>
                        <th>User Name</th>
                        <th>Email</th>
                        <th>Disease/Condition</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr><td colSpan="3">Loading...</td></tr>
                      ) : healthProfiles.length > 0 ? (
                        healthProfiles.map((item, index) => (
                          <tr key={index}>
                            <td>{item.user_name}</td>
                            <td>{item.email}</td>
                            <td>{item.disease_name}</td>
                          </tr>
                        ))
                      ) : (
                        <tr><td colSpan="3">No health profiles found.</td></tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserHealthProfiles;
